// extracted by mini-css-extract-plugin
module.exports = {"button":"GoatsTreeButton_button__2iNvH","button-show":"GoatsTreeButton_button-show__30_Ly"};